import React, { useRef, useState, useEffect } from 'react'
import Modal from '../../common/modal'
import { useForm, Controller } from "react-hook-form";
import InputWraper from '../../common/inputWraper';
import { Toast } from 'primereact/toast';

import {
    useQuery,
    useMutation,
    useQueryClient,
} from 'react-query'
import { getDevices } from '../../../Services/deviceMaster';
import { MultiSelect } from 'primereact/multiselect';

import './MultiSelectDemo.css';
import { getCode } from '../../../Services/codeMaster';

import { Fieldset } from 'primereact/fieldset';
import { saveProduct } from '../../../Services/productMaster';
const AddEditProduct = ({ product, isEdit = false, onSubmit, ...props }) => {

    const toast = useRef(null);


    const [devices, setDevices] = useState([])
    const [alarms, setAlaram] = useState([])
    const [isActionLoading, setIsActionLoading] = useState(false);


    const [lazyParams, setLazyParams] = useState({
        searchText: "",
        first: 0,
        rows: 10,
        page: 1,
        sortField: "",
        sortOrder: 0,

    });

    //Get Devices 
    const { data, isLoading } = useQuery(['productdevice', lazyParams], () => getDevices(lazyParams), {

        onError: (error) => {
            toast.current.show({ severity: 'error', summary: 'OOPS !!', detail: error.message, life: 3000 });
        },
    })


    //get Alarm Queries
    const { data: dataAlaram, refetch: reload, isLoading: loadingAlarm } = useQuery(['todoss', lazyParams], () => getCode(lazyParams), {
        keepPreviousData: true,
        onError: (error) => {
            toast.current.show({ severity: 'error', summary: 'OOPS !!', detail: error.message, life: 3000 });
        },
    })

    // React=query clinet to refeatch data, etc.. oprations
    const queryClient = useQueryClient()



    const { register, handleSubmit, formState: { errors }, control, reset, getValues, setValue } = useForm();


    const alarmTemplate = (option) => {
        return (
            <div className="country-item">
                <div>{option.get("code")} - {option.get("type") == 0 ? "Alarm" : "Opreation"}</div>
            </div>
        );
    }

    const submitProduct = (data) => {
        console.log(" devices, alarms", devices, alarms)
        return
        setIsActionLoading(true)
        saveProduct({ ...data, devices, alarms }).then((res) => {

            toast.current.show({ severity: 'success', summary: 'Product added !!!', detail: isEdit ? "Product update success" : "Product added success" });

            queryClient.invalidateQueries('products')

            setIsActionLoading(false)


        }).catch((error) => {
            setIsActionLoading(false)
            toast.current.show({ severity: 'error', summary: 'OOPS !!', detail: error.message, life: 3000 });

        })
        window.$('#Create').modal('hide')
        reset()

    }

    useEffect(() => {
        console.log("product edit", product)

        if (Object.entries(product).length !== 0) {

            setValue('name', product.get('name'))


            if (alarms.length == 0) {
                let selectedAlarm = []
                let code = product.get('codeId')[0]
                console.log("code",code)
                dataAlaram.results.forEach(el => {
                    code.map(item => {
                        if (item.id == el.id) {
                            selectedAlarm.push(el)
                        }

                    })
                })

                setAlaram(selectedAlarm)
            }

            if (devices.length == 0) {
                let selectedDevice = []
                let deviceIds = product.get('deviceId')[0]
                data.results.forEach(el => {
                    deviceIds.map(item => {
                        if (item.id == el.id) {
                            selectedDevice.push(el)
                        }

                    })
                })
                console.log("selectedDevice", selectedDevice)
                setDevices(selectedDevice)
            }
          
        }

    }, [isEdit])

    const resetFormnData = () => {
        console.log("canclled")
        reset();
        
        let a = alarms
        a.splice(0, a.length);
    
        setAlaram(a)
        setDevices(a)
        props.callback(false)
    }

    return (
        <React.Fragment>
            <Toast ref={toast} className="toastCustom" />
          
            <Modal id="Create"
                iconClass="fas fa-plus"
                title="Product Details"
                loading={isActionLoading}
                saveAction={handleSubmit(data => submitProduct(data))}
                cancelAction={() => {

                    window.$('#Create').modal('hide')
                    resetFormnData()


                }}

            >
                <form >
                    <div class="row">

                        <div class="col-lg-12">


                            <InputWraper id="name" title="Name" active={isEdit}>
                                <input type="text" id="name" className="form-control"  {...register("name")} defaultValue={isEdit ? '-2' : ""} />
                                {<div class="error">{errors.name?.message}</div>}
                            </InputWraper>


                        </div>
                        <div>

                        </div>

                        <div class="col-lg-12 d-flex justify-content-between">
                            <Fieldset legend="Select Devices">
                                {!isLoading && <MultiSelect maxSelectedLabels={3}
                                    optionLabel={(el) => el.get("name")}
                                    value={devices}
                                    options={data?.results}
                                    placeholder="Select a device(s)"

                                    onChange={(e) => { console.log(e.value); setDevices(e.value) }} />}
                            </Fieldset>
                            <Fieldset legend="Select Alarm">

                                {!loadingAlarm && <MultiSelect maxSelectedLabels={3}
                                    optionLabel={(el) => el.get("code")}
                                    value={alarms}
                                    options={dataAlaram?.results}
                                    itemTemplate={alarmTemplate}
                                    filter
                                    placeholder="Select a alarm(s)"
                                    onChange={(e) => { console.log(e.value); setAlaram(e.value) }} />}
                            </Fieldset>
                        </div>



                    </div>


                </form>
            </Modal>
        </React.Fragment>
    )
}

export default AddEditProduct
